import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AccreditationDateRange({
  createdAt,
  expiresAt
}) {
  if (!expiresAt) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Date: FormattedDateTime
      },
      message: "profilePage.AcademyProfile.accreditations.noExpirationDate_jsx",
      options: {
        value: createdAt,
        format: 'll'
      }
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedDateTime, {
      format: "ll",
      value: createdAt
    }), " -", ' ', /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "ll",
      value: expiresAt
    })]
  });
}